import { notification } from "antd";
import axios, { AxiosError } from "axios";
import { authorizedAxios } from "../../Actions/AxiosActions";
import { IBrand } from "../../Models/IBrand";
import { IGCPBigQueryJob } from "../../Models/IGCPBigQueryJob";
import { IGPSGetJobResult, IGPSGetJobResultParsed } from "../../Models/Models";
import { IGetJobsRequest } from "../../Models/Requests/IGetJobsRequest";
import { ISubmitMobilyticsJobRequest } from "../../Models/Requests/ISubmitMobilyticsJobRequest";
import { IGPSInsightsAxios } from "../index";

export class GPSInsightsAxios implements IGPSInsightsAxios {
    public GetUserJobs(request: IGetJobsRequest): Promise<IGCPBigQueryJob[]> {
        return new Promise<IGCPBigQueryJob[]>((resolve, reject) => {
            authorizedAxios("POST", "/services/gps/Job/byUser", null, request)
                .then(
                    (response: IGCPBigQueryJob[]) => {
                        resolve(response);
                    },
                    (error: AxiosError) => {
                        reject(error.message);
                    }
                )
                .catch((error: AxiosError) => {
                    console.log(`Error getting jobs: ${error.message}`);
                });
        });
    }

    public GetCompanyJobs(request: IGetJobsRequest): Promise<IGCPBigQueryJob[]> {
        return new Promise<IGCPBigQueryJob[]>((resolve, reject) => {
            authorizedAxios("POST", "/services/gps/Job/byCompany", null, request)
                .then(
                    (response: IGCPBigQueryJob[]) => {
                        resolve(response);
                    },
                    (error: AxiosError) => {
                        reject(error.message);
                    }
                )
                .catch((error: AxiosError) => {
                    console.log(`Error getting jobs: ${error.message}`);
                });
        });
    }

    public GetJob(jobId: string): Promise<IGCPBigQueryJob> {
        return new Promise<IGCPBigQueryJob>((resolve, reject) => {
            authorizedAxios("GET", `/services/gps/Mobilytics/${jobId}`)
                .then(
                    (response: IGCPBigQueryJob) => {
                        resolve(response);
                    },

                    (error: AxiosError) => {
                        reject(error.message);
                    }
                )
                .catch((error: AxiosError) => {
                    console.log(`Error getting job: ${error.message}`);
                });
        });
    }

    public DeleteJob(jobId: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            authorizedAxios("POST", `/services/gps/Job/delete/${jobId}`)
                .then(
                    (response: string) => {
                        resolve(response);
                    },

                    (error: AxiosError) => {
                        reject(error.message);
                    }
                )
                .catch((error: AxiosError) => {
                    console.log(`Error deleting job: ${error.message}`);
                });
        });
    }

    public GetBrand(term: string): Promise<IBrand> {
        return new Promise<IBrand>((resolve, reject) => {
            axios
                .get<IBrand>(`/services/gps/Brand/name/${term}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error.message);
                    }
                )
                .catch((error: AxiosError) => {
                    console.log(`Error getting brand: ${error.message}`);
                });
        });
    }

  public GetResults = (jobID: string): Promise<IGPSGetJobResultParsed> => {
      return new Promise<IGPSGetJobResultParsed>((resolve, reject) => {
          authorizedAxios("GET", `/services/gps/Mobilytics/${jobID}/results`)
              .then(
                  (response: IGPSGetJobResult) => {
                      const polygons = [response.job[0].jobPolygon];
                      if (response.job.length > 1) {
                          polygons.push(response.job[1].jobPolygon);
                      }
                      const result: IGPSGetJobResultParsed = {
                          polygon: polygons,
                          data: response.chartData,
                          job: response.job,
                          benchmarkCommonData: response.benchmarkCommonData,
                      };
                      resolve(result);
                  },
                  (error: AxiosError) => {
                      reject(error);
                  }
              )
              .catch((error: AxiosError) => {
                  console.log(`Error getting results: ${error.message}`);
              });
      });
  };

  public SubmitGpsReport = (
      request: ISubmitMobilyticsJobRequest
  ): Promise<any> => {
      return new Promise<any>((resolve, reject) => {
          authorizedAxios("POST", "/services/gps/Mobilytics/submit", {}, request)
              .then(
                  (response: any) => {
                      resolve(response);
                  },
                  (error: AxiosError) => {
                      reject(error.message);
                  }
              )
              .catch((error: AxiosError) => {
                  notification.error({
                      message: "Error",
                      description: error.response.data.Message,
                      duration: null, // user must close
                  });
              });
      });
  };

  public updatePolygonName = (
      jobId: string,
      newName: string
  ): Promise<IGCPBigQueryJob> => {
      return new Promise<IGCPBigQueryJob>((resolve, reject) => {
          authorizedAxios(
              "POST",
              `/services/gps/Mobilytics/UpdatePolygonName`,
              {},
              { jobId, newName }
          )
              .then(
                  (response: IGCPBigQueryJob) => {
                      resolve(response);
                  },
                  (error: AxiosError) => {
                      reject(error.message);
                  }
              )
              .catch((error: AxiosError) => {
                  notification.error({
                      message: "Error",
                      description: error.response.data.Message,
                      duration: null, // user must close
                  });
              });
      });
  };
  public updateJobTitle = (
      jobId: string,
      newReportName: string
  ): Promise<IGCPBigQueryJob> => {
      return new Promise<IGCPBigQueryJob>((resolve, reject) => {
          authorizedAxios(
              "PUT",
              `/services/gps/Job/UpdateJobTitle/${jobId}`,
              {},
              { jobId, newReportName }
          )
              .then(
                  (response: IGCPBigQueryJob) => {
                      resolve(response);
                  },
                  (error: AxiosError) => {
                      reject(error.message);
                  }
              )
              .catch((error: AxiosError) => {
                  notification.error({
                      message: "Error",
                      description: error.response.data.Message,
                      duration: null, // user must close
                  });
              });
      });
  };
  public SaveToScout = (jobId: string): Promise<any> => {
      return new Promise<any>((resolve, reject) => {
          authorizedAxios(
              "POST",
              `/services/gps/Mobilytics/savetoscout`,
              {},
              {
                  jobId: jobId,
                  save: true,
              }
          )
              .then(
                  (response: any) => {
                      resolve(response);
                  },
                  (error: AxiosError) => {
                      reject(error.message);
                  }
              )
              .catch((error: AxiosError) => {
                  notification.error({
                      message: "Error",
                      description: error.response.data.Message,
                      duration: null, // user must close
                  });
              });
      });
  };
}

/******************** Share Report ********************/
export const saveSharedReport = (
    jobId: string,
    callback: (shareReportGuid: string) => void
) => {
    authorizedAxios<string>(
        "POST",
        `/services/gps/share/SaveSharedReport/${jobId}`
    )
        .then((reportGuid: string) => {
            callback(reportGuid);
        })
        .catch((error) => {
            console.log(`Error: ${error}`);
        });
};
